import React from "react";

function Transformacion() {
    return (
        <div className="container m-auto my-12">
            <div className="flex flex-col justify-center items-center my-12">
                <h1 className="text-2xl font-times font-bold">
                    Casos de Tranformación
                </h1>

                <div className="grid grid-cols-1 md:grid-cols-2 gap-12 mx-8 py-8 h-auto">

                    <div className="flex flex-col justify-center items-center my-8 border-1 shadow-2xl md:mx-10 shadow-slate-400 border-gray-400 p-5 rounded-md">
                        <h2 className="text-xl text-justify font-times font-bold">
                            Caso 1 – Empresario sin claridad estratégica
                        </h2>
                        <p className="text-justify text-xl font-times">
                            <span className="text-justify font-bold">Situación inicial:</span><br />
                            Tenía múltiples ideas, pero falta de enfoque, desorden en prioridades y decisiones poco claras.<br />
                            <span className="text-justify font-bold">Intervención:</span><br />
                            Se trabajó en mentalidad, claridad estratégica y toma de decisiones.<br />
                            <span className="text-justify font-bold">Resultado:</span>
                        </p>
                        <ul >
                            <li className="text-justify text-xl font-times"><span className="text-green-500 text-xl mx-3">✓</span>Definición clara de objetivos</li>
                            <li className="text-justify text-xl font-times"><span className="text-green-500 text-xl mx-3">✓</span>Mayor seguridad en decisiones</li>
                            <li className="text-justify text-xl font-times"><span className="text-green-500 text-xl mx-3">✓</span>Enfoque en acciones de alto impacto</li>
                            <li className="text-justify text-xl font-times"><span className="text-green-500 text-xl mx-3">✓</span>Crecimiento en organización personal y empresarial</li>
                        </ul>
                    </div>

                    <div className="flex flex-col justify-center items-center my-8 border-1 shadow-2xl md:mx-10 shadow-slate-400 border-gray-400 p-5 rounded-md">
                        <h2 className="text-xl text-justify font-times font-bold">
                            Caso 2 – Profesional con baja confianza
                        </h2>
                        <p className="text-justify text-xl font-times">
                            <span className="text-justify font-bold">Situación inicial:</span><br/>
                            Inseguridad, dudas constantes y dificultad para avanzar en proyectos personales.<br/>
                            <span className="text-justify font-bold">Intervención:</span><br/>
                            Trabajo en creencias limitantes, mentalidad y enfoque.<br/>
                            <span className="text-justify font-bold">Resultado:</span>

                        </p>
                        <ul>
                            <li className="text-justify text-xl font-times"><span className="text-green-500 text-xl mx-3">✓</span>Mayor confianza personal</li>
                            <li className="text-justify text-xl font-times"><span className="text-green-500 text-xl mx-3">✓</span>Claridad en objetivos</li>
                            <li className="text-justify text-xl font-times"><span className="text-green-500 text-xl mx-3">✓</span>Toma de acción constante</li>
                            <li className="text-justify text-xl font-times"><span className="text-green-500 text-xl mx-3">✓</span>Cambio en su forma de pensar y actuar</li>
                        </ul>
                    </div>

                </div>


                <div className="flex flex-col justify-center items-center my-8 border-1 shadow-2xl  mx-10 shadow-slate-400 border-gray-400 p-5 rounded-md">
                    <h2 className="text-xl text-justify font-times font-bold">
                        Caso 3 – Equipo desalineado
                    </h2>
                    <p className="text-justify text-xl font-times">
                        <span>Situación inicial:</span><br/>
                        Falta de comunicación, baja claridad en objetivos y poco compromiso del equipo.<br/>
                        <span>Intervención:</span><br/>
                        Trabajo en liderazgo, comunicación y alineación de visión.<br/>
                        <span>Resultado:</span>

                    </p>
                    <ul>
                        <li className="text-justify text-xl font-times"><span className="text-green-500 text-xl mx-3">✓</span>Mejora en comunicación interna</li>
                        <li className="text-justify text-xl font-times"><span className="text-green-500 text-xl mx-3">✓</span>Mayor compromiso del equipo</li>
                        <li className="text-justify text-xl font-times"><span className="text-green-500 text-xl mx-3">✓</span>Claridad en roles y objetivos</li>
                        <li className="text-justify text-xl font-times"><span className="text-green-500 text-xl mx-3">✓</span>Incremento en productividad</li>
                    </ul>
                </div>

                <div className="flex justify-center items-center my-12 mx-16">
                    <h1 className="text-justify text-2xl font-times font-bold">
                        Los Resultados Cambian Cuando La Mentalidad Cambia… Y Cuando El Liderazgo Evoluciona, Todo El Sistema Mejora.
                    </h1>
                </div>

            </div>
        </div>
    )
}

export default Transformacion;